import { RiCloseLine } from "react-icons/ri";
import Typography from "../Typography";
import Button from "../Button/Button";

const CommonModal = ({
  isOpen,
  onClose,
  title,
  children,
  width = "max-w-md",
  loading = false,
  /** Extra classes on the scrollable body (e.g. `max-w-none` for wide tables). */
  bodyClassName = "",
}) => {
  if (!isOpen) return null;

  const handleOverlayClick = () => {
    if (!loading) onClose();
  };

  return (
    <div
      className="fixed inset-0 bg-black bg-opacity-50 z-[9999] flex items-center justify-center p-4"
      onClick={handleOverlayClick}
    >
      <div
        className={`bg-surface-primary rounded-lg shadow-lg w-full ${width} relative max-h-[90vh] flex flex-col overflow-hidden mx-auto`}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div className="flex items-center justify-between p-4 border-b border-border-primary flex-shrink-0">
          <Typography variant="h5" className="font-semibold text-text-primary">
            {title}
          </Typography>

          <Button
            type="button"
            onClick={onClose}
            disabled={loading}
            className="!text-text-secondary hover:!text-text-primary transition-colors !border-0 !shadow-none !bg-transparent !p-0 !px-0 !py-0 !font-normal !inline-flex !items-center !justify-center disabled:opacity-50 disabled:cursor-not-allowed"
            aria-label="Close modal"
          >
            <RiCloseLine className="w-5 h-5" />
          </Button>
        </div>

        {/* Body — capped height; scroll when content exceeds viewport */}
        <div
          className={[
            "p-4 min-h-0 max-h-[calc(90vh-5.5rem)] overflow-y-auto overflow-x-auto",
            bodyClassName,
          ]
            .filter(Boolean)
            .join(" ")}
        >
          {children}
        </div>
      </div>
    </div>
  );
};

export default CommonModal;
